import React from 'react';
import { List, ListItem } from '@mui/material';

import type { ReportConfigCombinations } from 'src/types/reportConfig';
import type { CurrentReport } from 'src/components/workspace/components/WorkspaceActionBanner/components/ConfigureReport';

export const reportKey = ({
  reportName,
  reportType,
  fileType,
  language,
}: CurrentReport) => `${reportName}-${reportType}-${language}-${fileType}`;

export const reportInfo = (
  report: CurrentReport,
  reportConfigCombinations?: ReportConfigCombinations,
) => {
  if (!reportConfigCombinations) {
    // fallback for error cases:
    return `${report.reportName}: ${report.reportType}, ${report.language}, ${report.fileType}`;
  }

  const content = reportConfigCombinations.content ?? {};

  const reportTypeName =
    content.reportTypes?.[report.reportType]?.[report.fileType]?.name ??
    String(report.reportType);

  const languageName =
    content.languages?.[report.language]?.name ?? String(report.language);

  const fileTypeName =
    content.fileTypes?.[report.fileType]?.abbreviation ??
    String(report.fileType);

  return `${report.reportName}: ${reportTypeName}, ${languageName}, ${fileTypeName}`;
};

const OrderedReportsList = ({
  reports = [],
  reportConfigCombinations,
}: {
  reports: CurrentReport[];
  reportConfigCombinations?: ReportConfigCombinations;
}) => {
  if (reports.length < 1) return null;
  return (
    <>
      <span>Ordered Reports:</span>
      <List>
        {reports.map((report) => (
          <ListItem key={reportKey(report)}>
            {reportInfo(report, reportConfigCombinations)}
          </ListItem>
        ))}
      </List>
    </>
  );
};

export default OrderedReportsList;
